export default __webpack_public_path__ + "static/media/youtube-white.39b87b6a.svg";